import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-agree-terms-popup',
  templateUrl: './agree-terms-popup.component.html',
  styleUrls: ['./agree-terms-popup.component.scss']
})
export class AgreeTermsPopupComponent {
  public content: string = '';
  public agree: boolean = false;
  @ViewChild('termText') termText!:ElementRef;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AgreeTermsPopupComponent>,
  ) {
    this.content = data.content;
  }

  

ngAfterViewInit() {
 this.termText.nativeElement.insertAdjacentHTML('beforeend', this.content);
}


}
